import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { View } from "ui/atoms/view";
import { Button } from "ui/gluestack/button";
import { Text } from "react-native";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  isDeleting: boolean;
  onSubmit: () => void;
}

export function DeleteResidentModal({
  isVisible,
  onClose,
  isDeleting,
  onSubmit,
}: Props) {
  return (
    <ReusableModal
      isVisible={isVisible}
      onClose={onClose}
      className="w-full max-w-[378px] mx-auto"
      title="Are you sure you want to delete this resident?"
      description="This action will permanently delete the resident and all associated data. Please confirm if you want to proceed."
      hasCancelButton
    >
      <View className="flex flex-row justify-end gap-x-4 ">
        <Button action="primary" size="sm" variant="outline" onPress={onClose}>
          <Text className="text-primary-500 font-semibold">Cancel</Text>
        </Button>
        <Button
          action="negative"
          size="sm"
          isDisabled={isDeleting}
          onPress={onSubmit}
        >
          <Text className="text-white">Delete</Text>
        </Button>
      </View>
    </ReusableModal>
  );
}
